import { useEffect, useState } from 'react';
import { Box, Container, Portal, Tab, Tabs } from '@mui/material';
import PortalPageHeader from '../../common/PortalPageHeader';
import { PageDetails } from '../config';
import TabPanel from '../../common/TabPanel';
import { Datatable } from './Datatable';

export default function Courses() {
  const id = 'courses';
  const [title, setTitle] = useState('');
  const tabs = ['Current Semester', 'Next Semester'];
  const [selectedTab, setSelectedTab] = useState(0);

  // Retrieves page title from pageDetails using pageid
  useEffect(() => {
    const loadPageTitle = () => {
      const page = PageDetails[id];
      setTitle(page.title);
    };
    loadPageTitle();
  }, []);

  return (
    <div id={`${id}__div_pageWrapper`} className={`myOdu__${id} myOdu__ats`}>
      <Container
        id={`${id}__container_pageWrapper`}
        className="myOdu__container secondaryPage rightSideFullWidth"
      >
        <PortalPageHeader id={id} title={title} breadcrumbs={PageDetails[id].breadcrumbs} />
        <Box id={`${id}__box_wrapper`} className={'wrapper'}>
          <Box
            id={`${id}__box_tabsWrapper`}
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
            }}
          >
            <Tabs
              id={`${id}__tabs`}
              className="myOdu__tabs"
              value={selectedTab}
              onChange={(event, value) => setSelectedTab(value)}
              aria-label={'Choose Semester'}
            >
              {tabs.map((sem, index) => (
                <Tab
                  key={`${id}__tab_${index}`}
                  label={sem}
                  id={`${id}__tab_${index}`}
                  aria-controls={`${id}__tabPanel_${index}`}
                />
              ))}
            </Tabs>
          </Box>
          {tabs.map((_, index) => {
            return (
              <TabPanel
                key={`${id}__tabPanel_${index}`}
                value={selectedTab}
                index={index}
                id={`${id}__tabPanel_${index}`}
                className="myOdu__tabPanel pt-0 px-0"
                labelledby={`${id}__tab_${index}`}
              >
                <Datatable isNextTerm={selectedTab === 1} id={id} />
              </TabPanel>
            );
          })}
        </Box>
      </Container>
    </div>
  );
}
